// extracted by mini-css-extract-plugin
export default {"content":"employees_content__poOd8"};